module.exports = __webpack_public_path__ + "static/img/city-mob-red-ar-1.ae4034f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/red-about/city-mob-red-ar-1.png
// module id = 1250
// module chunks = 4